<template>
  <div class="pa-5">
    <v-flex id="header-container">
      <div class="d-flex align-center">
        <p class="headline d-inline-block mb-0">
          {{ botTemplate.name || 'Cargando...' }}
        </p>
        <v-btn fab icon small @click="botDialog = true" :disabled="isLoading">
          <v-icon>
            fas fa-pencil-alt
          </v-icon>
        </v-btn>
      </div>
      <v-select id="header-select" v-if="hasStaging" v-model="index" :items="versions" class="white--text" color="grey"
        solo>
      </v-select>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="elevation-2 white">
          <v-card-text class="pa-0">
            <flow-tree
              :key="getKey"
              :data="flow"
              @edit-intention="editIntention" />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-3 v-if="!isLoading">
      <v-flex xs12 class="text-xs-right">
        <v-btn class="k-orange-linear white--text mr-0" large @click="startSave">
          Guardar
        </v-btn>
      </v-flex>
    </v-layout>
    <bot-dialog
      :show="botDialog"
      :title="botDialogTitle"
      :data="botDialogData"
      :show-types="false"
      @close="botDialog = false"
      @save="editBotTemplate">
    </bot-dialog>
    <text-dialog
      :show="textDialog"
      :data="activeIntentionData"
      :title="activeTitle"
      :send-call-center-option="activeIntention.send_call_center"
      @save="saveIntention"
      @close="textDialog = false" />
    <question-dialog
      :show="questionDialog"
      :data="activeIntentionData"
      :title="activeTitle"
      @save="saveIntention"
      @close="questionDialog = false"/>
    <payment-promise-dialog
      :show="paymentPromiseDialog"
      :data="activeIntentionData"
      :title="activeTitle"
      @save="saveIntention"
      @close="paymentPromiseDialog = false"/>
    <double-check 
      :show="showChecker"
      @accept="doubleCheckPassed"
      @close="showChecker = false"/>
  </div>
</template>

<script>
import BotDialog from '@/components/bot_v4/BotDialog';
import FlowTree from '@/components/bot_v4/Detail/FlowTree';
import TextDialog from '@/components/bot_v4/Detail/TextDialog';
import DoubleCheck from '@/components/templateV2/modal/DoubleCheck';
import QuestionDialog from '@/components/bot_v4/Detail/QuestionDialog';
import PaymentPromiseDialog from '@/components/bot_v4/Detail/PaymentPromiseDialog';
import EventBus from '@/event-bus';
import _ from 'lodash';
import Vue from 'vue';

const uuidv1 = require('uuid/v1');

export default {
  components: {
    BotDialog,
    FlowTree,
    TextDialog,
    DoubleCheck,
    QuestionDialog,
    PaymentPromiseDialog,
  },
  data() {
    return {
      // Templates vars
      showChecker: false,
      index: 'actual',
      templates: {},
      versions: [
        {
          value: 'actual',
          text: 'Actual',
        },
        {
          value: 'staging',
          text: 'Próxima carga',
        },
      ],
      stagingActive: false,
      hasStaging: false,
      createStaging: false,
      // Old versions vars
      isLoading: true,
      botDialog: false,
      textDialog: false,
      questionDialog: false,
      paymentPromiseDialog: false,
      activeIntention: {},
      currentParent: '',
      flowKey: uuidv1(),
      botTemplate: {},
      customerConfirmationFlow: [
        {
          icon: 'fas fa-home',
          title: 'Saludo inicial',
          name: 'WELCOME',
          data: {
            text: '',
            afternoon_text: '',
          },
        },
        {
          icon: 'fas fa-question',
          title: 'Confirmación cliente',
          name: 'CUSTOMER_CONFIRMATION',
          data: {
            text: '',
            fallback_text: '',
            failed_attempts_text: '',
            max_attempts: 3,
            sms: [
              {
                status_id: 13,
                text: '',
                enabled: false,
              },
              {
                status_id: 33,
                text: '',
                enabled: false,
              },
            ],
          },
          childrens: [
            {
              icon: 'fas fa-check',
              title: 'Dar mensaje de cobro',
              name: 'COLLECT',
              send_call_center: true,
              data: {
                text: '',
                send_call_center: false,
                call_center_number: '',
              },
            },
            {
              icon: 'fas fa-times',
              title: 'No es el cliente',
              name: 'WRONG_PERSON',
              data: {
                text: '',
              },
            },
          ],
        },
        {
          icon: 'fas fa-phone-slash',
          title: 'Despedida',
          name: 'GOODBYE',
          data: {
            text: '',
          },
        },
      ],
      paymentPromiseFlow: [
        {
          icon: 'fas fa-home',
          title: 'Saludo inicial',
          name: 'WELCOME',
          data: {
            text: '',
            afternoon_text: '',
          },
        },
        {
          icon: 'fas fa-question',
          title: 'Confirmación cliente',
          name: 'CUSTOMER_CONFIRMATION',
          data: {
            text: '',
            fallback_text: '',
            failed_attempts_text: '',
            max_attempts: 3,
            sms: [
              {
                status_id: 13,
                text: '',
                enabled: false,
              },
              {
                status_id: 33,
                text: '',
                enabled: false,
              },
            ],
          },
          childrens: [
            {
              icon: 'fas fa-check',
              title: 'Dar mensaje de cobro',
              name: 'COLLECT',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-calendar',
                  title: 'Fecha de compromiso',
                  name: 'PAYMENT_PROMISE',
                  send_call_center: true,
                  data: {
                    text: '',
                    invalid_date_text: '',
                    max_days: 7,
                    allow_next_month_promise: true,
                    send_call_center: false,
                    call_center_number: '',
                    send_email: false,
                    sms: [
                      {
                        status_id: 8,
                        text: '',
                        enabled: false,
                      },
                    ],
                    // email: {
                    //   company_email_id: '',
                    //   subject: '',
                    //   text: '',
                    // },
                  },
                },
                {
                  icon: 'fas fa-calendar-times',
                  title: 'Sin compromiso',
                  name: 'NO_COMMITMENT',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                    sms: [
                      {
                        status_id: 35,
                        text: '',
                        enabled: false,
                      },
                    ],
                  },
                },
                {
                  icon: 'fas fa-money-bill-wave',
                  title: 'Pagado',
                  name: 'ALREADY_PAID',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                  },
                },
              ],
            },
            {
              icon: 'fas fa-times',
              title: 'Confirmación de recado',
              name: 'ASK_RELATIONSHIP',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-user-check',
                  title: 'Conoce al cliente',
                  name: 'LEAVE_MESSAGE',
                  data: {
                    text: '',
                  },
                },
                {
                  icon: 'fas fa-user-times',
                  title: 'No conoce al cliente',
                  name: 'WRONG_PERSON',
                  data: {
                    text: '',
                  },
                },
              ],
            },
          ],
        },
        {
          icon: 'fas fa-phone-slash',
          title: 'Despedida',
          name: 'GOODBYE',
          data: {
            text: '',
          },
        },
      ],
      noCommitmentFlow: [
        {
          icon: 'fas fa-home',
          title: 'Saludo inicial',
          name: 'WELCOME',
          data: {
            text: '',
            afternoon_text: '',
          },
        },
        {
          icon: 'fas fa-question',
          title: 'Confirmación cliente',
          name: 'CUSTOMER_CONFIRMATION',
          data: {
            text: '',
            fallback_text: '',
            failed_attempts_text: '',
            max_attempts: 3,
            sms: [
              {
                status_id: 13,
                text: '',
                enabled: false,
              },
              {
                status_id: 33,
                text: '',
                enabled: false,
              },
            ],
          },
          childrens: [
            {
              icon: 'fas fa-check',
              title: 'Dar mensaje de cobro',
              name: 'COLLECT',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-calendar',
                  title: 'Fecha de compromiso',
                  name: 'PAYMENT_PROMISE',
                  send_call_center: true,
                  data: {
                    text: '',
                    invalid_date_text: '',
                    max_days: 7,
                    allow_next_month_promise: true,
                    send_call_center: false,
                    call_center_number: '',
                    send_email: false,
                    sms: [
                      {
                        status_id: 8,
                        text: '',
                        enabled: false,
                      },
                    ],
                    // email: {
                    //   company_email_id: '',
                    //   subject: '',
                    //   text: '',
                    // },
                  },
                },
                {
                  icon: 'fas fa-calendar-times',
                  title: 'Sin compromiso',
                  name: 'NO_COMMITMENT',
                  data: {
                    text: '',
                    fallback_text: '',
                    failed_attempts_text: '',
                    max_attempts: 3,
                  },
                  childrens: [
                    {
                      icon: 'fas fa-tools',
                      title: 'Problemas técnicos',
                      name: 'TECHNICAL_ISSUES',
                      send_call_center: true,
                      data: {
                        text: '',
                        send_call_center: false,
                        call_center_number: '',
                      },
                    },
                    {
                      icon: 'fas fa-chart-bar',
                      title: 'Problemas económicos',
                      name: 'ECONOMIC_ISSUES',
                      send_call_center: true,
                      data: {
                        text: '',
                        send_call_center: false,
                        call_center_number: '',
                      },
                    },
                    {
                      icon: 'fas fa-user-minus',
                      title: 'Disconformidad en el cobro',
                      name: 'DEBT_DISAGREEMENT',
                      send_call_center: true,
                      data: {
                        text: '',
                        send_call_center: false,
                        call_center_number: '',
                      },
                    },
                  ],
                },
                {
                  icon: 'fas fa-money-bill-wave',
                  title: 'Pagado',
                  name: 'ALREADY_PAID',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                  },
                },
              ],
            },
            {
              icon: 'fas fa-times',
              title: 'Confirmación de recado',
              name: 'ASK_RELATIONSHIP',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-user-check',
                  title: 'Conoce al cliente',
                  name: 'LEAVE_MESSAGE',
                  data: {
                    text: '',
                  },
                },
                {
                  icon: 'fas fa-user-times',
                  title: 'No conoce al cliente',
                  name: 'WRONG_PERSON',
                  data: {
                    text: '',
                  },
                },
              ],
            },
          ],
        },
        {
          icon: 'fas fa-phone-slash',
          title: 'Despedida',
          name: 'GOODBYE',
          data: {
            text: '',
          },
        },
      ],
      saleFlow: [
        {
          icon: 'fas fa-home',
          title: 'Saludo inicial',
          name: 'WELCOME',
          data: {
            text: '',
            afternoon_text: '',
          },
        },
        {
          icon: 'fas fa-question',
          title: 'Confirmación cliente',
          name: 'CUSTOMER_CONFIRMATION',
          data: {
            text: '',
            fallback_text: '',
            failed_attempts_text: '',
            max_attempts: 3,
            sms: [
              {
                status_id: 13,
                text: '',
                enabled: false,
              },
              {
                status_id: 33,
                text: '',
                enabled: false,
              },
            ],
          },
          childrens: [
            {
              icon: 'fas fa-check',
              title: 'Dar oferta',
              name: 'GIVE_OFFER',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-check-double',
                  title: 'Acepta oferta',
                  name: 'OFFER_ACCEPTED',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                  },
                },
                {
                  icon: 'fas fa-thumbs-down',
                  title: 'Rechaza oferta',
                  name: 'OFFER_DECLINED',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                  },
                },
              ],
            },
            {
              icon: 'fas fa-times',
              title: 'Confirmación de recado',
              name: 'ASK_RELATIONSHIP',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-user-check',
                  title: 'Conoce al cliente',
                  name: 'LEAVE_MESSAGE',
                  data: {
                    text: '',
                  },
                },
                {
                  icon: 'fas fa-user-times',
                  title: 'No conoce al cliente',
                  name: 'WRONG_PERSON',
                  data: {
                    text: '',
                  },
                },
              ],
            },
          ],
        },
        {
          icon: 'fas fa-phone-slash',
          title: 'Despedida',
          name: 'GOODBYE',
          data: {
            text: '',
          },
        },
      ],
      customerConfirmationBasicFlow: [
        {
          icon: 'fas fa-home',
          title: 'Saludo inicial',
          name: 'WELCOME',
          data: {
            text: '',
            afternoon_text: '',
          },
        },
        {
          icon: 'fas fa-question',
          title: 'Confirmación cliente',
          name: 'CUSTOMER_CONFIRMATION',
          data: {
            text: '',
            fallback_text: '',
            failed_attempts_text: '',
            max_attempts: 3,
            sms: [
              {
                status_id: 13,
                text: '',
                enabled: false,
              },
              {
                status_id: 33,
                text: '',
                enabled: false,
              },
            ],
          },
          childrens: [
            {
              icon: 'fas fa-check',
              title: 'Dar mensaje de cobro',
              name: 'COLLECT',
              send_call_center: true,
              data: {
                text: '',
                send_call_center: false,
                call_center_number: '',
              },
            },
            {
              icon: 'fas fa-times',
              title: 'No es el cliente',
              name: 'WRONG_PERSON',
              data: {
                text: '',
              },
            },
          ],
        },
        {
          icon: 'fas fa-phone-slash',
          title: 'Despedida',
          name: 'GOODBYE',
          data: {
            text: '',
          },
        },
      ],
      paymentPromiseBasicFlow: [
        {
          icon: 'fas fa-home',
          title: 'Saludo inicial',
          name: 'WELCOME',
          data: {
            text: '',
            afternoon_text: '',
          },
        },
        {
          icon: 'fas fa-question',
          title: 'Confirmación cliente',
          name: 'CUSTOMER_CONFIRMATION',
          data: {
            text: '',
            fallback_text: '',
            failed_attempts_text: '',
            max_attempts: 3,
            sms: [
              {
                status_id: 13,
                text: '',
                enabled: false,
              },
              {
                status_id: 33,
                text: '',
                enabled: false,
              },
            ],
          },
          childrens: [
            {
              icon: 'fas fa-check',
              title: 'Dar mensaje de cobro',
              name: 'COLLECT',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-calendar',
                  title: 'Fecha de compromiso',
                  name: 'PAYMENT_PROMISE',
                  send_call_center: true,
                  data: {
                    text: '',
                    invalid_date_text: '',
                    max_days: 7,
                    allow_next_month_promise: true,
                    send_call_center: false,
                    call_center_number: '',
                    send_email: false,
                    sms: [
                      {
                        status_id: 8,
                        text: '',
                        enabled: false,
                      },
                    ],
                    // email: {
                    //   company_email_id: '',
                    //   subject: '',
                    //   text: '',
                    // },
                  },
                },
                {
                  icon: 'fas fa-calendar-times',
                  title: 'Sin compromiso',
                  name: 'NO_COMMITMENT',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                    sms: [
                      {
                        status_id: 35,
                        text: '',
                        enabled: false,
                      },
                    ],
                  },
                },
                {
                  icon: 'fas fa-money-bill-wave',
                  title: 'Pagado',
                  name: 'ALREADY_PAID',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                  },
                },
              ],
            },
            {
              icon: 'fas fa-times',
              title: 'Confirmación de recado',
              name: 'ASK_RELATIONSHIP',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-user-check',
                  title: 'Conoce al cliente',
                  name: 'LEAVE_MESSAGE',
                  data: {
                    text: '',
                  },
                },
                {
                  icon: 'fas fa-user-times',
                  title: 'No conoce al cliente',
                  name: 'WRONG_PERSON',
                  data: {
                    text: '',
                  },
                },
              ],
            },
          ],
        },
        {
          icon: 'fas fa-phone-slash',
          title: 'Despedida',
          name: 'GOODBYE',
          data: {
            text: '',
          },
        },
      ],
      paymentPromiseBasicMailFlow: [
        {
          icon: 'fas fa-home',
          title: 'Saludo inicial',
          name: 'WELCOME',
          data: {
            text: '',
            afternoon_text: '',
          },
        },
        {
          icon: 'fas fa-question',
          title: 'Confirmación cliente',
          name: 'CUSTOMER_CONFIRMATION',
          data: {
            text: '',
            fallback_text: '',
            failed_attempts_text: '',
            max_attempts: 3,
            // sms: [
            //   {
            //     status_id: 13,
            //     text: '',
            //     enabled: false,
            //   },
            //   {
            //     status_id: 33,
            //     text: '',
            //     enabled: false,
            //   },
            // ],
          },
          childrens: [
            {
              icon: 'fas fa-check',
              title: 'Dar mensaje de cobro',
              name: 'COLLECT',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-calendar',
                  title: 'Fecha de compromiso',
                  name: 'PAYMENT_PROMISE',
                  send_call_center: true,
                  data: {
                    text: '',
                    invalid_date_text: '',
                    max_days: 7,
                    allow_next_month_promise: true,
                    send_call_center: false,
                    call_center_number: '',
                    send_email: false,
                    // sms: [
                    //   {
                    //     status_id: 8,
                    //     text: '',
                    //     enabled: false,
                    //   },
                    // ],
                    // email: {
                    //   company_email_id: '',
                    //   subject: '',
                    //   text: '',
                    // },
                  },
                  childrens: [
                    {
                      icon: 'fas fa-question',
                      title: 'Confirmacion por mail',
                      name: 'MAIL_CONFIRMATION',
                      data: {
                        text: '',
                        fallback_text: '',
                        failed_attempts_text: '',
                        max_attempts: 3,
                      },
                      childrens: [
                        {
                          icon: 'fas fa-check',
                          title: 'Enviar mail',
                          name: 'SEND_MAIL',
                          data: {
                            text: '',
                          },
                        },
                        {
                          icon: 'fas fa-times',
                          title: 'No enviar mail',
                          name: 'NOT_SEND_MAIL',
                          data: {
                            text: '',
                          },
                        },
                      ],
                    }
                  ],
                },
                {
                  icon: 'fas fa-calendar-times',
                  title: 'Sin compromiso',
                  name: 'NO_COMMITMENT',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                    // sms: [
                    //   {
                    //     status_id: 35,
                    //     text: '',
                    //     enabled: false,
                    //   },
                    // ],
                  },
                },
                {
                  icon: 'fas fa-money-bill-wave',
                  title: 'Pagado',
                  name: 'ALREADY_PAID',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                  },
                },
              ],
            },
            {
              icon: 'fas fa-times',
              title: 'Confirmación de recado',
              name: 'ASK_RELATIONSHIP',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-user-check',
                  title: 'Conoce al cliente',
                  name: 'LEAVE_MESSAGE',
                  data: {
                    text: '',
                  },
                },
                {
                  icon: 'fas fa-user-times',
                  title: 'No conoce al cliente',
                  name: 'WRONG_PERSON',
                  data: {
                    text: '',
                  },
                },
              ],
            },
          ],
        },
        {
          icon: 'fas fa-phone-slash',
          title: 'Despedida',
          name: 'GOODBYE',
          data: {
            text: '',
          },
        },
      ],
      noCommitmentBasicFlow: [
        {
          icon: 'fas fa-home',
          title: 'Saludo inicial',
          name: 'WELCOME',
          data: {
            text: '',
            afternoon_text: '',
          },
        },
        {
          icon: 'fas fa-question',
          title: 'Confirmación cliente',
          name: 'CUSTOMER_CONFIRMATION',
          data: {
            text: '',
            fallback_text: '',
            failed_attempts_text: '',
            max_attempts: 3,
            sms: [
              {
                status_id: 13,
                text: '',
                enabled: false,
              },
              {
                status_id: 33,
                text: '',
                enabled: false,
              },
            ],
          },
          childrens: [
            {
              icon: 'fas fa-check',
              title: 'Dar mensaje de cobro',
              name: 'COLLECT',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-calendar',
                  title: 'Fecha de compromiso',
                  name: 'PAYMENT_PROMISE',
                  send_call_center: true,
                  data: {
                    text: '',
                    invalid_date_text: '',
                    max_days: 7,
                    allow_next_month_promise: true,
                    send_call_center: false,
                    call_center_number: '',
                    send_email: false,
                    sms: [
                      {
                        status_id: 8,
                        text: '',
                        enabled: false,
                      },
                    ],
                    // email: {
                    //   company_email_id: '',
                    //   subject: '',
                    //   text: '',
                    // },
                  },
                },
                {
                  icon: 'fas fa-calendar-times',
                  title: 'Sin compromiso',
                  name: 'NO_COMMITMENT',
                  data: {
                    text: '',
                    fallback_text: '',
                    failed_attempts_text: '',
                    max_attempts: 3,
                  },
                  childrens: [
                    {
                      icon: 'fas fa-tools',
                      title: 'Problemas técnicos',
                      name: 'TECHNICAL_ISSUES',
                      send_call_center: true,
                      data: {
                        text: '',
                        send_call_center: false,
                        call_center_number: '',
                      },
                    },
                    {
                      icon: 'fas fa-chart-bar',
                      title: 'Problemas económicos',
                      name: 'ECONOMIC_ISSUES',
                      send_call_center: true,
                      data: {
                        text: '',
                        send_call_center: false,
                        call_center_number: '',
                      },
                    },
                    {
                      icon: 'fas fa-user-minus',
                      title: 'Disconformidad en el cobro',
                      name: 'DEBT_DISAGREEMENT',
                      send_call_center: true,
                      data: {
                        text: '',
                        send_call_center: false,
                        call_center_number: '',
                      },
                    },
                  ],
                },
                {
                  icon: 'fas fa-money-bill-wave',
                  title: 'Pagado',
                  name: 'ALREADY_PAID',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                  },
                },
              ],
            },
            {
              icon: 'fas fa-times',
              title: 'Confirmación de recado',
              name: 'ASK_RELATIONSHIP',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-user-check',
                  title: 'Conoce al cliente',
                  name: 'LEAVE_MESSAGE',
                  data: {
                    text: '',
                  },
                },
                {
                  icon: 'fas fa-user-times',
                  title: 'No conoce al cliente',
                  name: 'WRONG_PERSON',
                  data: {
                    text: '',
                  },
                },
              ],
            },
          ],
        },
        {
          icon: 'fas fa-phone-slash',
          title: 'Despedida',
          name: 'GOODBYE',
          data: {
            text: '',
          },
        },
      ],
      saleBasicFlow: [
        {
          icon: 'fas fa-home',
          title: 'Saludo inicial',
          name: 'WELCOME',
          data: {
            text: '',
            afternoon_text: '',
          },
        },
        {
          icon: 'fas fa-question',
          title: 'Confirmación cliente',
          name: 'CUSTOMER_CONFIRMATION',
          data: {
            text: '',
            fallback_text: '',
            failed_attempts_text: '',
            max_attempts: 3,
            sms: [
              {
                status_id: 13,
                text: '',
                enabled: false,
              },
              {
                status_id: 33,
                text: '',
                enabled: false,
              },
            ],
          },
          childrens: [
            {
              icon: 'fas fa-check',
              title: 'Dar oferta',
              name: 'GIVE_OFFER',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-check-double',
                  title: 'Acepta oferta',
                  name: 'OFFER_ACCEPTED',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                  },
                },
                {
                  icon: 'fas fa-thumbs-down',
                  title: 'Rechaza oferta',
                  name: 'OFFER_DECLINED',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                  },
                },
              ],
            },
            {
              icon: 'fas fa-times',
              title: 'Confirmación de recado',
              name: 'ASK_RELATIONSHIP',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-user-check',
                  title: 'Conoce al cliente',
                  name: 'LEAVE_MESSAGE',
                  data: {
                    text: '',
                  },
                },
                {
                  icon: 'fas fa-user-times',
                  title: 'No conoce al cliente',
                  name: 'WRONG_PERSON',
                  data: {
                    text: '',
                  },
                },
              ],
            },
          ],
        },
        {
          icon: 'fas fa-phone-slash',
          title: 'Despedida',
          name: 'GOODBYE',
          data: {
            text: '',
          },
        },
      ],
      flow: [],
    };
  },
  created() {
    Promise.all([
      this.axios.get(`bot_templates/${this.$route.params.botTemplate}`).then(({ data }) => data),
      this.axios.get(`/templates/staging/bot/${this.$route.params.botTemplate}`).then(({ data }) => data),
    ]).then((data) => {
      const [template] = data;

      if (template.type === 'colly') {
        return Vue.$router.push('/bot_templates');
      }

      const [,[staging]] = data;
      this.templates.actual = template;
      this.setFlow(template);
      if (staging) {
        this.templates.staging = {
          name: (template || {}).name,
          id: staging.template_id,
          bot_config: staging.body,
          type: staging.type,
          voice: staging.voice,
        };
        this.hasStaging = true;
      }
    });
  },
  computed: {
    getKey() {
      return this.botTemplate.key || null;
    },
    botDialogTitle() {
      return `Editar plantilla ${this.botTemplate.name}`;
    },
    botDialogData() {
      return {
        name: this.botTemplate.name,
        voice: this.botTemplate.voice,
      };
    },
    activeIntentionData() {
      return this.activeIntention.data || {};
    },
    activeTitle() {
      const intentionTitle = String(this.activeIntention.title).toLowerCase();
      return `Editar texto de ${intentionTitle}`;
    },
  },
  methods: {
    // Template staging && Double check methods
    doubleCheckPassed(e) {
      if (e.value === 'after load') {
        this.createStaging = true;
      }
      this.save();
    },
    startSave() {
      if (this.hasStaging) {
        this.save();
      } else {
        this.showChecker = true;
      }
    },
    // Flow Methods
    map(flow, item) {
      const intention = {
        ...item,
      };
      const data = {};
      Object.keys(item.data).forEach((key) => {
        const value = flow[item.name][key];
        if (value !== undefined) {
          data[key] = value;
        }
      });
      intention.data = {
        ...intention.data,
        ...data,
      };
      if (item.childrens) {
        item.childrens.forEach((item2, i) => {
          intention.childrens[i] = {
            ...item.childrens[i],
            ...this.map(flow, item2),
          };
        });
      }
      return intention;
    },
    setFlow(data) {
      this.flow = [
        ...this[`${_.camelCase(data.type)}Flow`],
      ];

      const flow = JSON.parse(data.bot_config);
      if (Object.keys(flow).length) {
        const tmpFlow = [
          ...this.flow,
        ];
        for (let i = 0; i < tmpFlow.length; i += 1) {
          tmpFlow[i] = this.map(flow, tmpFlow[i]);
        }
        this.flow = [
          ...tmpFlow,
        ];
      }
      this.botTemplate = data;
      this.botTemplate.key = uuidv1();
      this.isLoading = false;
    },
    buildFlow() {
      const flow = {};
      const map = (item) => {
        flow[item.name] = {
          ...item.data,
        };
        if (item.childrens) {
          item.childrens.forEach((item2) => {
            map(item2);
          });
        }
      };
      this.flow.forEach(map);
      return { body: flow, textMissing: this.textMissing(flow) };
    },
    textMissing(flow) {
      const flowKeys = Object.keys(flow);
      let textMissing = false;
      loop1: // eslint-disable-line
      for (let i = 0; i < flowKeys.length; i += 1) {
        const currentKey = flowKeys[i];
        const textKeys = Object.keys(flow[currentKey]).filter(key => key.includes('text'));
        for (let b = 0; b < textKeys.length; b += 1) {
          if (!flow[currentKey][textKeys[b]]) {
            EventBus.$emit('modal', 'Faltan textos');
            textMissing = true;
            this.showChecker = false;
            break loop1; // eslint-disable-line
          }
        }
      }
      return textMissing;
    },
    // Old methods
    editBotTemplate(form) {
      this.botTemplate.name = form.name;
      this.botTemplate.voice = form.voice;
      this.botDialog = false;
    },
    editIntention({ intention, parent }) {
      this.currentParent = parent;
      this.activeIntention = intention;
      this.blurDialog(true);
    },
    blurDialog(val) {
      if (
        this.activeIntention.name === 'CUSTOMER_CONFIRMATION'
        || this.activeIntention.name === 'ASK_RELATIONSHIP'
        || this.activeIntention.name === 'GIVE_OFFER'
        || (
          (this.botTemplate || {}).type === 'no_commitment'
          && this.activeIntention.name === 'NO_COMMITMENT'
        )
        || (
          this.activeIntention.name === 'COLLECT'
          && (this.botTemplate || {}).type !== 'customer_confirmation'
        )
        || this.activeIntention.name === 'MAIL_CONFIRMATION'
      ) {
        this.questionDialog = val;
      } else if (this.activeIntention.name === 'PAYMENT_PROMISE') {
        this.paymentPromiseDialog = val;
      } else {
        this.textDialog = val;
      }
    },
    saveIntention(form) { // eslint-disable-line
      const obj = [
        ...this.flow,
      ];
      const arr = this.currentParent.slice(0, this.currentParent.length - 1)
        .replace(/\[/g, '')
        .split(']');
      let position = '';
      for (let i = 0; i < arr.length; i += 1) {
        position += `[${arr[i]}]`;
        if (i !== arr.length - 1) {
          position += '.childrens';
        }
      }
      const str = `obj${position}.data`;
      // eslint-disable-next-line
      eval(`${str} = {
        ...${str},
        ...form,
      };`);
      this.flow = [
        ...obj,
      ];
      this.flowKey = uuidv1();
      this.blurDialog(false);
    },
    save() {
      const flow = this.buildFlow();
      if (flow.textMissing) {
        return;
      }
      if (this.index === 'actual' && !this.createStaging) {
        this.axios.patch(`bot_templates/${this.botTemplate.id}`, {
          name: this.botTemplate.name,
          voice: this.botTemplate.voice,
          bot_config: JSON.stringify(flow.body),
        })
          .then(() => {
            this.templates.actual = {
              ...this.botTemplate,
              bot_config: JSON.stringify(flow.body),
            };
            EventBus.$emit('modal', 'Guardado exitoso');
          })
          .catch(() => {
            EventBus.$emit('modal', 'Ocurrio un error al guardar la plantilla. Por favor intente nuevamente');
          })
          .finally(() => {
            this.showChecker = false;
          });
      } else if (this.createStaging) {
        // Creando plantilla para despues la proxima carga
        this.axios.post('templates/staging', {
          type: this.botTemplate.type,
          voice: this.botTemplate.voice,
          text: JSON.stringify(flow.body),
          template_id: this.botTemplate.id,
          company_id: this.$auth.user().company_id,
          channel_id: 4,
        })
          .then(() => {
            this.templates.staging = {
              ...this.botTemplate,
              bot_config: JSON.stringify(flow.body),
            };
            this.createStaging = false;
            this.hasStaging = true;
            this.index = 'staging';
            EventBus.$emit('modal', 'Guardado exitoso, los cambios se aplicaran en la siguiente carga');
          })
          .catch(() => {
            EventBus.$emit('modal', 'Ocurrio un error al guardar la plantilla. Por favor intente nuevamente');
          })
          .finally(() => {
            this.showChecker = false;
          });
      } else if (this.hasStaging && this.stagingActive) {
        // Actualizando la plantilla que correra en la proxima carga
        this.axios.patch(`templates/staging/${this.botTemplate.id}`, {
          type: this.botTemplate.type,
          voice: this.botTemplate.voice,
          text: JSON.stringify(flow.body),
          template_id: this.botTemplate.id,
          company_id: this.$auth.user().company_id,
          channel_id: 4,
        })
          .then(() => {
            this.templates.staging = {
              ...this.botTemplate,
              bot_config: JSON.stringify(flow.body),
            };
            this.index = 'staging';
            EventBus.$emit('modal', 'Guardado exitoso, los cambios se aplicaran en la siguiente carga');
          })
          .catch(() => {
            EventBus.$emit('modal', 'Ocurrio un error al guardar la plantilla. Por favor intente nuevamente');
          })
          .finally(() => {
            this.showChecker = false;
          });
      }
    },
  },
  watch: {
    index() {
      if (Object.keys(this.templates[this.index]).length) {
        this.stagingActive = !this.stagingActive;
        this.setFlow(this.templates[this.index]);
      }
    },
  },
};
</script>

<style scoped>
  #header-container {
    display: flex;
    align-items: center;
    margin-bottom: 2vh !important;
    justify-content: space-between;
  }

  #header-select {
    max-width: 17vw !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/bot_v4/Detail/Index.vue